import { MutableRefObject, useCallback, useRef, useState } from 'react';

/**
 * Based on https://www.npmjs.com/package/react-usestateref
 * Inspired: struggling to get the current state
 * In React when functions accessing the state they receive the state from the moment the function defined - not the current state.
 * So if the state changed, your functions and effects my use older state.
 * Using useRef, can solve it because it have always one value. But when you update the Ref it's not re-render.
 */
export const useStateRef = <Type>(defaultValue: Type): [Type, (input: Type) => void, MutableRefObject<Type>] => {
  const [state, setState] = useState<Type>(defaultValue);
  const ref = useRef<Type>(state);

  const dispatch: (val: Type) => void = useCallback(val => {
    ref.current = typeof val === 'function' ?
      val(ref.current) : val;

    setState(ref.current);
  }, []);

  return [state, dispatch, ref];
};
